$(document).ready(function () {
    $(document).on('click', '.block__cart-drawer-item-btn-qty', function () {
        let $this = $(this);
        let qty = parseInt($this.parent('.block__cart-drawer-item-qtybox').find('.block__cart-drawer-item-quantity-input').val());
        if ($this.hasClass('block__cart-drawer-item-qtyplus')) {
            qty++;
        } else {
            if (qty > 0) {
                qty--;
            }
        }
        qty = (isNaN(qty)) ? 0 : qty;
        $this.parent('.block__cart-drawer-item-qtybox').find('.block__cart-drawer-item-quantity-input').val(qty);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        CartItemChange(id, qty)
    });

    $(document).on("click",".js-art-drawer-item-remove",function(){
        let $this = $(this);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let qty = 0;
        CartItemChange(id, qty)  
    });

    $(".js-cart-drawer-item-quantity-input").on("change",function(){
        let $this = $(this);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let qty = $this.val();
        CartItemChange(id, qty)   
    });

    $(document).on("click",".js-header-cart-drawer",function(event){
        event.preventDefault();
        $(".js-cart-drawer-section").addClass("active");
        $(".js-cart-drawer-overlay").addClass("active");
        $("body").addClass("overflow-hidden");
    });

    $(document).on("click",".js-cart-drawer-close, .js-cart-drawer-overlay",function(event){
        event.preventDefault();
        $(".js-cart-drawer-section").removeClass("active");
        $(".js-cart-drawer-overlay").removeClass("active");
        $("body").removeClass("overflow-hidden");
    });

    $(document).on("click",".js-cart-drawer-item-detail-subscribe-btn",function(event){
        event.preventDefault();
        let $this = $(this);
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let newid = $this.attr("js-new-product-id");
        let qty = parentElement.attr("js-data-variant-qty");
        $(".js-cart-drawer-item-detail-subscribe-btn").attr('disabled',true);
        CartItemUpdate(id, newid, qty, {_ess360_sub_switch: 'cart'});
    });

    // Use event delegation so it works even after AJAX updates
    $(document).on("change", ".js-cart-item-product-option", function(){
        let $this = $(this);
        $(".js-cart-item-product-option").prop('disabled', 'disabled');
        cartItemOptionUpdate($this);
    });

    function cartItemOptionUpdate($this){
        let selectedValue = $this.val();
        let data_index = $this.attr("data-index");
        let parentElement = $this.parents(".js-cart-drawer-item-box");
        let id = parentElement.attr("js-data-variant-id");
        let qty = parentElement.attr("js-data-variant-qty");

        let optionTwo_Array = [];
        let optionThree_Array = [];

        var selected_option_two = $(".js-cart-item-product-option-2").val();
        var selected_option_three = $(".js-cart-item-product-option-3").val();
        if(data_index == "options-1"){
            $this.parents(".block__cart-item-product-options-list").find(".variant_select option[data-option1='"+selectedValue+"']").each(function(){
                if($(this).attr("data-option2") != ''){
                    optionTwo_Array.push($(this).attr("data-option2"))
                } 
                if($(this).attr("data-option3") != ''){
                    let optionThreeselecteValue = $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-2").val();
                    if(optionThreeselecteValue == $(this).attr("data-option2")){
                        optionThree_Array.push($(this).attr("data-option3"))
                    }
                } 
            });
        }

        if(data_index == "options-2"){
            $this.parents(".block__cart-item-product-options-list").find(".variant_select option[data-option2='"+selectedValue+"']").each(function(){
                if($(this).attr("data-option3") != ''){
                    let optionThreeselecteValue = $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-2").val();
                    if(optionThreeselecteValue == $(this).attr("data-option2")){
                        optionThree_Array.push($(this).attr("data-option3"))
                    }
                } 
            });
        }


        if(optionTwo_Array.length > 0){
            var uniqueOptionTwo_Array = [...new Set(optionTwo_Array)];
            let optionTwoOptiones;
            $(uniqueOptionTwo_Array).each(function(index, value){
                if(value != ''){
                    if(value == selected_option_two){
                        optionTwoOptiones += "<option value='"+value+"' selected>"+value+"</option>";
                    }else{
                        optionTwoOptiones += "<option value='"+value+"'>"+value+"</option>";
                    }
                    
                }
            });
            $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-2").html(optionTwoOptiones);
        }
        
        if(optionThree_Array.length > 0){
            var uniqueOptionThree_Array = [...new Set(optionThree_Array)];
            let optionThreeOptiones;
            $(uniqueOptionThree_Array).each(function(index, value){
                if(value != ''){
                    if(value == selected_option_three){
                        optionThreeOptiones += "<option value='"+value+"' selected>"+value+"</option>";
                    }else{
                        optionThreeOptiones += "<option value='"+value+"'>"+value+"</option>";
                    }
                }
            });
            $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option-3").html(optionThreeOptiones);
        }

        let FinalselectedValue = [];
        $this.parents(".block__cart-item-product-options-list").find(".js-cart-item-product-option").each(function(){
            FinalselectedValue.push($(this).val());
        });

        let arrayJoin = FinalselectedValue.join(' / ');
        let newid = $this.parents(".block__cart-item-product-options-list").find(".variant_select option[data-value='"+arrayJoin+"']").attr("data-id");

        if (!newid) {
            // Variant not found - don't proceed with update
            return;
        }

        // Switched back to one-time via the dropdowns: drop the subscribe
        // button's stamp, or the order reads as a subscription switch.
        // Cross-sell stamps still carry through.
        let isSubscription = /subscription|every|weeks/i.test(arrayJoin);
        CartItemUpdate(id, newid, qty, null, isSubscription ? [] : ['_ess360_sub_switch']);
    }

    // extraProperties (optional): stamped onto the re-added line, e.g. the
    // _ess360_sub_switch attribution from the subscribe button. The old
    // line's own properties (notably _ess360_cross_sell* stamps on
    // cross-sold lines) are carried through — the change+add swap would
    // otherwise drop them. Mirrors subSwitchAttributes in the checkout
    // extension (ESS360-checkout repo, recurring.ts).
    // dropProperties (optional): keys NOT carried over from the old line.
    function CartItemUpdate(id, newid, qty, extraProperties, dropProperties){
        $(".js-cart-drawer-item-btn-qty, .js-cart-drawer-item-quantity-input").attr("disabled", true);
        $(".js-cart-drawer-footer-cart-btn-submit").addClass("js-cart-update-runing").attr("disabled", true);

        $.getJSON('/cart.js', function(cart) {
            var properties = {};
            for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].key === id && cart.items[i].properties) {
                    for (var k in cart.items[i].properties) {
                        properties[k] = cart.items[i].properties[k];
                    }
                    break;
                }
            }
            if (dropProperties) {
                for (var d = 0; d < dropProperties.length; d++) delete properties[dropProperties[d]];
            }
            if (extraProperties) {
                for (var e in extraProperties) properties[e] = extraProperties[e];
            }

            $.ajax({
                url: '/cart/change.js',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify({
                    id: id,
                    quantity: 0
                }),
                success: function(respones) {
                    $.ajax({
                        url: '/cart/add.js',
                        type: 'POST',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify({
                            id: newid,
                            quantity: qty,
                            properties: properties
                        }),
                        success: function(respones) {
                            CartDrawerRefresh();
                        }
                    });
                }
            });
        });
    }

    $(document).on("click",".js-product-form-add-btn",function(event){
        event.preventDefault();
        let $this = $(this);

        let FormSerialize = $this.parents("form").serialize();
        $this.addClass("loading").attr("disabled",true);
        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: FormSerialize,
            success:function(data) {
                CartDrawerRefresh(function() {
                    $(".js-cart-drawer-overlay, .js-cart-drawer-section").addClass("active");
                });
            },
            complete: function(){
                $this.removeClass("loading").attr("disabled",false);
            },
            error: function (error) {
                $this.removeClass("loading").attr("disabled",false);
            }
        });
    });

    function CartItemChange(id, qty){
        $(".js-cart-drawer-item-btn-qty, .js-cart-drawer-item-quantity-input").attr("disabled", true);
        $(".js-cart-drawer-footer-cart-btn-submit").addClass("js-cart-update-runing").attr("disabled", true);
        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                id: id,
                quantity: qty
            }),
            success: function(respones) {
              CartDrawerRefresh()
            }
          });
    }

    var freedomPlusSkus = ['F121S','F121S-AS','F122M','F122M-AS','F123L','F123L-AS','F124X','F124X-AS','F125D','F125D-AS','F126T','F126T-AS'];

    function CartDrawerRefresh(onReady) {
        $.ajax({
            url: '/?section_id=new-cart-drawer',
            type: 'GET',
            dataType: 'html',
            success: function (carthtml) {
                $(".js-cart-drawer-section").html($(carthtml).find(".js-cart-drawer-section").html());
                $.getJSON('/cart.js',function(cart){
                    $(".js-cart-item-count").text(cart.item_count);
                    var fpBlocked = false;
                    cart.items.forEach(function(item) {
                        if (freedomPlusSkus.indexOf(item.sku) !== -1 && item.quantity > 1) {
                            fpBlocked = true;
                        }
                    });
                    if (fpBlocked) {
                        var $btn = $('.block__cart-drawer-footer-cart-btn-submit').hide();
                        if ($btn.siblings('.fp-limit-message').length === 0) {
                            $btn.parent().append('<p class="fp-limit-message" style="text-align: center; color: #cc0000; font-size: 14px; padding: 16px;">You cannot proceed to checkout with more than one $12.95 Trial Offer in your cart. Please remove 1 to continue to checkout.</p>');
                        }
                    }
                    if (onReady) onReady();
                });
            },
            complete: function (){
                loadJsAfterCartDrawer();
            }
        });
    }

    function loadJsAfterCartDrawer(){
        // Event delegation used instead - no need to re-bind
        $(".js-cart-drawer-item-quantity-input").on("change",function(){
            let $this = $(this);
            let parentElement = $this.parents(".js-cart-drawer-item-box");
            let id = parentElement.attr("js-data-variant-id");
            let qty = $this.val();
            CartItemChange(id, qty)
        });
    }

    // Global cart change listener for Replo and external cart updates
    let cartRefreshTimeout;
    function debouncedCartRefresh() {
        clearTimeout(cartRefreshTimeout);
        cartRefreshTimeout = setTimeout(function() {
            CartDrawerRefresh();
        }, 500); // Debounce to avoid multiple rapid refreshes
    }

    // Listen for Shopify cart update events
    $(document).on('cart:change', function() {
        debouncedCartRefresh();
    });

    // Run FP check every time the cart drawer becomes visible, regardless of how it was opened
    var cartDrawerEl = document.querySelector('.js-cart-drawer-section');
    if (cartDrawerEl) {
        var drawerWasActive = false;
        new MutationObserver(function(mutations) {
            var isNowActive = cartDrawerEl.classList.contains('active');
            if (isNowActive && !drawerWasActive) {
                CartDrawerRefresh();
            }
            drawerWasActive = isNowActive;
        }).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    // Intercept AJAX calls to cart endpoints from external sources
    $(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && (
            settings.url.includes('/cart/add') ||
            settings.url.includes('/cart/change') ||
            settings.url.includes('/cart/update')
        )) {
            // Skip if it's our own cart drawer request (already handled)
            if (!$(event.target).hasClass('js-cart-drawer-item-btn-qty') &&
                !$(event.target).hasClass('js-product-form-add-btn') &&
                !$(event.target).hasClass('js-cart-drawer-item-detail-subscribe-btn')) {
                debouncedCartRefresh();
            }
        }
    });
});